import { H2 } from 'UIComponents/elements/headings';
import styled, { css, mediaQuery, theme } from 'academy-common-lib/utils/Styling';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { PlaylistNavigationDropdown } from '../../playlistContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HEADER_STICKY_POSITION = 48;
const StyledUIHeader = styled(UIFlex).withConfig({
  displayName: "LearningContentPageHeader__StyledUIHeader",
  componentId: "sc-1iv2bju-0"
})(["position:sticky;z-index:2;top:", "px;border-bottom:1px solid ", ";background-color:", ";margin:0;padding:16px 23px;min-height:76px;", ""], HEADER_STICKY_POSITION, theme.colors.BATTLESHIP, theme.colors.OLAF, mediaQuery('tablet', css(["padding:16px 11px;min-height:60px;"])));
const Title = styled(H2).withConfig({
  displayName: "LearningContentPageHeader__Title",
  componentId: "sc-1iv2bju-1"
})(["margin:0;flex:1;", " ", ""], mediaQuery('tablet', css(["font-size:16px;"])), mediaQuery('mobile', css(["font-size:16px;"])));
export const LearningContentPageHeader = ({
  title,
  item,
  children
}) => {
  return /*#__PURE__*/_jsxs(StyledUIHeader, {
    align: "center",
    direction: "row",
    wrap: "nowrap",
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [item && !!item.playlistId && /*#__PURE__*/_jsx(PlaylistNavigationDropdown, {
        item: item
      }), /*#__PURE__*/_jsx(Title, {
        children: title
      })]
    }), children && /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(UIFlex, {
        align: "center",
        gap: 12,
        children: children
      })
    })]
  });
};